import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import RSVPStatusComponent from "../Components/CardView/RSVPStatusComponent";
import GiftReservedComponent from "../Components/CardView/GiftReservedComponent";
import GuestWishComponent from "../Components/CardView/GuestWishComponent";
import { useAuth } from "../Context/AuthContext";
import "../CSS/UserProfilePage.css";

const TABS = [
  { id: "rsvp", label: "RSVP" },
  { id: "gift", label: "Hadiah" },
  { id: "ucapan", label: "Ucapan" }
];

const DashboardPage = () => {
  const { uniqueCode } = useParams();
  const [searchParams] = useSearchParams();
  const { cards } = useAuth();

  const card = cards.find((c) => c.uniqueCode === uniqueCode);
  const packageType = card?.packageType || card?.package;
  const isBasic = packageType === "Basic";
  const isPremium = packageType === "Premium";

  // RSVP is hidden for Basic package
  // "ucapan" is always visible
  // "gift" is Premium-only
  const visibleTabs = TABS.filter((tab) => {
    if (tab.id === "rsvp") return !isBasic;
    if (tab.id === "gift") return isPremium;
    return true;
  });

  const requestedTab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(() => {
    if (requestedTab) return requestedTab;
    return isBasic ? "ucapan" : "rsvp";
  });

  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.some((t) => t.id === activeTab)) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <div className="profile-page">
      <div className="profile-inner">

        {/* Title */}
        <h1 className="profile-title">Dashboard</h1>

        {/* Pill tab bar — only show if there's more than one tab */}
        {visibleTabs.length > 1 && (
          <div className="profile-tabs" role="tablist">
            {visibleTabs.map((tab) => (
              <button
                key={tab.id}
                id={`tab-${tab.id}`}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                aria-controls={`tabpanel-${tab.id}`}
                className={`profile-tab ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {/* RSVP Tab Panel */}
        {!isBasic && (
          <div
            role="tabpanel"
            id="tabpanel-rsvp"
            aria-labelledby="tab-rsvp"
            hidden={activeTab !== "rsvp"}
          >
            {activeTab === "rsvp" && (
              <RSVPStatusComponent cardId={uniqueCode} hideNavbar={false} />
            )}
          </div>
        )}

        {/* Hadiah Tab Panel — Premium only */}
        {isPremium && (
          <div
            role="tabpanel"
            id="tabpanel-gift"
            aria-labelledby="tab-gift"
            hidden={activeTab !== "gift"}
          >
            {activeTab === "gift" && (
              <GiftReservedComponent uniqueCode={uniqueCode} />
            )}
          </div>
        )}

        {/* Ucapan (Guest Wish) Tab Panel — always available */}
        <div
          role="tabpanel"
          id="tabpanel-ucapan"
          aria-labelledby="tab-ucapan"
          hidden={activeTab !== "ucapan"}
        >
          {activeTab === "ucapan" && (
            <GuestWishComponent uniqueCode={uniqueCode} />
          )}
        </div>

      </div>
    </div>
  );
};

export default DashboardPage;
